<script setup>
import { ref, defineProps, defineEmits, onMounted, onUnmounted } from 'vue';
import { fetchLicenseById } from '@/services/api';
import Modal from '@/components/modals/BaseModal.vue';
import { useLayoutComponents } from '@/composables/layout';

const { MarkdownRenderer } = useLayoutComponents();
const formatedLicenseData = ref(null);
const licenseDescription = ref(null);
const licenseName = ref(null);
const tags = ref([]);
const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    licenseData: {
        type: Object,
        default: () => {}
    }
});

const emit = defineEmits(['close']);

const handleClose = () => {
    emit('close');
}

onMounted(async () => {
    if (!props.licenseData.licenseId) return;
    const response = await fetchLicenseById(props.licenseData.licenseId);
    if (!response) return;
    
    const additionalClauses = convertCustomClausesToMarkdown();
    
    let content = response.content;
    content = content.replace('{{duration}}', `${props.licenseData.yearsDuration ?? 1} year${props.licenseData.yearsDuration > 1 ? 's' : ''}`);
    content = content.replace('{{additional_clauses}}', additionalClauses);
    
    formatedLicenseData.value = content;
    licenseDescription.value = response.short_description;
    licenseName.value = response.name;
    tags.value = response.tags ?? [];
});

onUnmounted(() => {
    formatedLicenseData.value = null;
    licenseDescription.value = null;
    licenseName.value = null;
    tags.value = [];
});

const convertCustomClausesToMarkdown = () => {
    let result = '';
    props?.licenseData?.customClauses?.forEach(clause => {
        result += `## ${clause.name}\n\n${clause.content}\n\n`;
    });
    return result;
}

</script>

<template>
    <Modal 
        v-model:show="props.show" 
        :title="`${licenseName ?? 'Preview License'}`" 
        @close="handleClose"
        :modalSize="modalSize"
        :closeOnClickOutside="true"
        :showCancelButton="false"
        :buttonText="'Close'"
    >
        <template #description>
            <div class="flex flex-col gap-1" v-if="tags.length > 0 || licenseDescription">
                <div class="flex gap-2" v-if="tags.length > 0">
                    <div class="text-xs text-echoes-background-gray bg-white/70 rounded-full px-2 font-semibold leading-none py-1" v-for="tag in tags" :key="tag">
                        {{ tag }}
                    </div>
                </div>
                <div class="text-sm text-white/50 font-semibold" v-if="licenseDescription">
                    {{ licenseDescription }}
                </div>
            </div>
        </template>
        <div class="max-h-[60vh] overflow-y-scroll bg-black p-3">
            <MarkdownRenderer v-model="formatedLicenseData" :contentOnly="true" :enableImageUpload="false" />
        </div>
    </Modal>
</template>